import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/oneteg-new-logo.png'
import _imports_1 from './assets/small-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-39d5c5d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "sidebar-nav",
  style: {"width":"100%"}
}
const _hoisted_2 = {
  key: 1,
  style: {"margin-left":"3px"}
}
const _hoisted_3 = { class: "parentHeading" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  id: "sidebar-footer",
  class: "mt-auto"
}

import { onBeforeMount, onMounted, onUnmounted, ref, watch } from "vue";
import { ElMenu, ElMenuItem, ElSubMenu, ElTooltip } from "element-plus";
import { currentRoute } from "@/core/router";
import {
  navMenuItems,
  NavMenuItem,
  menuItemsWithParent,
  menuItemsWithChildren,
  sidebarCollapsed,
} from "@/core/layout";
import { authInfo, hasPermission } from "@/core/auth";


export default /*#__PURE__*/_defineComponent({
  __name: 'Sidebar',
  setup(__props) {

const selected = ref("");

const isCollapsed = ref(false);

function toggleSidebar() {
  isCollapsed.value = !isCollapsed.value;
}

const menuItems: NavMenuItem[] = [];
const sortedMenuItemsWithParent: NavMenuItem[] = [];
const sortedMenuItemsWithChildren: NavMenuItem[] = [];

function spliceAndSortMenuItems() {
  navMenuItems
    .sort((a, b) => b.rank - a.rank)
    .forEach((item) => {
      if (hasPermission(item.authority) || !item.authority) {
        if (!(item.hasParent || item.isParent)) {
          menuItems.push(item);
        }
      }
    });
  menuItemsWithParent
    .sort((a, b) => b.rank - a.rank)
    .forEach((item) => {
      if (hasPermission(item.authority)) {
        sortedMenuItemsWithParent.push(item);
      }
    });
  menuItemsWithChildren
    .sort((a, b) => b.rank - a.rank)
    .forEach((item) => {
      if (hasPermission(item.authority)) {
        sortedMenuItemsWithChildren.push(item);
      }
    });
}

watch(
  () => authInfo.value,
  () => {
    spliceAndSortMenuItems();
  }
);

onBeforeMount(() => {
  spliceAndSortMenuItems();
});

watch(
  () => isCollapsed.value,
  () => {
    sidebarCollapsed.value = isCollapsed.value;
  }
);

onMounted(() => {
  const width = window.innerWidth;
  isCollapsed.value = width <= 1130;

  watch(
    () => currentRoute.value.name,
    () => {
      selected.value = currentRoute.value.path;
    }
  );

  selected.value = currentRoute.value.path;

  window.addEventListener("resize", myEventHandler);
});

onUnmounted(() => {
  window.removeEventListener("resize", myEventHandler);
});

function myEventHandler() {
  const width = window.innerWidth;
  isCollapsed.value = width <= 1280;
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    id: "sidebar",
    class: _normalizeClass([{ collapsed: isCollapsed.value }, "d-flex flex-column"])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["sidebar-header d-flex justify-content-start border-bottom-lightgray", !isCollapsed.value ? 'justify-content-start' : 'justify-content-center']),
      style: {"height":"35px"}
    }, [
      (!isCollapsed.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            alt: "logo",
            class: "logo",
            style: {"margin-left":"7px"},
            src: _imports_0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
          }))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            alt: "logo",
            class: "logo",
            src: _imports_1,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/')))
          }))
    ], 2),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(ElMenu), {
        collapse: isCollapsed.value,
        "background-color": "linear-gradient(to bottom right, #2B3A51, #5F95BF)",
        class: "el-menu-vertical-demo",
        "text-color": "#404B6CFF"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navMenuItems)
            .sort((a, b) => b.rank - a.rank)
            .filter((item) => _unref(hasPermission)(item.authority) || !item.authority), (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (isCollapsed.value)
                ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                    placement: "right",
                    effect: "custom",
                    content: item.label,
                    key: 'tooltip-' + item.name
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElMenuItem), {
                        index: 'menu-' + item.name,
                        id: 'menu-' + item.name,
                        class: _normalizeClass([{ active: selected.value.includes(item.name) }, "font-size"]),
                        style: {"height":"46px","line-height":"46px"},
                        onClick: ($event: any) => (_ctx.$router.push(item.targetRoute.path))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, {
                            icon: item.iconName,
                            class: "icon-size-m"
                          }, null, 8, ["icon"])
                        ]),
                        _: 2
                      }, 1032, ["index", "id", "class", "onClick"])
                    ]),
                    _: 2
                  }, 1032, ["content"]))
                : (_openBlock(), _createBlock(_unref(ElMenuItem), {
                    index: 'menu-' + item.name,
                    id: 'menu-' + item.name,
                    class: _normalizeClass([{ active: selected.value.includes(item.name) }, "font-size"]),
                    style: {"height":"46px","line-height":"46px"},
                    onClick: ($event: any) => (_ctx.$router.push(item.targetRoute.path)),
                    key: 'menuitem-' + item.name
                  }, {
                    default: _withCtx(() => [
                      (!isCollapsed.value)
                        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                            key: 0,
                            icon: item.iconName,
                            class: "fa-fw icon-size-sm"
                          }, null, 8, ["icon"]))
                        : _createCommentVNode("", true),
                      (!isCollapsed.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(item.label), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["index", "id", "class", "onClick"]))
            ], 64))
          }), 256)),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sortedMenuItemsWithParent, (item) => {
            return _createVNode(_unref(ElSubMenu), {
              index: "{{item.rank}}",
              key: item.name
            }, _createSlots({
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sortedMenuItemsWithChildren, (ele) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (item.rank === ele.rank)
                      ? (_openBlock(), _createBlock(_unref(ElMenuItem), {
                          index: ele.name,
                          key: ele.name,
                          class: _normalizeClass([{ active: selected.value.includes(ele.name) }, "font-size"]),
                          onClick: ($event: any) => (_ctx.$router.push(ele.targetRoute.path))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, {
                              icon: ele.iconName,
                              class: _normalizeClass(isCollapsed.value ? 'icon-size-m' : 'icon-size-sm')
                            }, null, 8, ["icon", "class"]),
                            (!isCollapsed.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_4, " " + _toDisplayString(ele.label), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["index", "class", "onClick"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 64))
              ]),
              _: 2
            }, [
              (item.isParent)
                ? {
                    name: "title",
                    fn: _withCtx(() => [
                      _createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1)
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1024)
          }), 64))
        ]),
        _: 1
      }, 8, ["collapse"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("a", {
        id: "collapse-button",
        href: "#",
        onClick: toggleSidebar
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: !isCollapsed.value ? 'compress' : 'expand',
          style: {"color":"#50b0ff"},
          size: "2x"
        }, null, 8, ["icon"])
      ])
    ])
  ], 2))
}
}

})